import { useQuery } from "@tanstack/react-query";

import { api, call, type Food } from "../api/client";

export const FOOD_INDEX_KEY = ["foods", "index"] as const;

export function fetchFoodIndex() {
  return call(api.GET("/api/v1/foods", { params: { query: { scope: "all", limit: 100 } } }));
}

/** Your foods (and the first catalog foods), saved on the device for offline search. */
export function useFoodIndex() {
  return useQuery({ queryKey: FOOD_INDEX_KEY, queryFn: fetchFoodIndex });
}

/** The same matching as the server: every word must appear in the name or brand. */
export function searchLocally(foods: Food[], q: string): Food[] {
  const words = q.toLowerCase().split(/\s+/).filter(Boolean);
  return foods.filter((f) => {
    const text = `${f.name} ${f.brand ?? ""}`.toLowerCase();
    return words.every((w) => text.includes(w));
  });
}
